import Env from './env'

var config = {}
if (Env === 'development') {
  config = {
    env: Env,
    baseUrl: 'http://47.93.233.49:8765/api/v1/'
  }
} else if (Env === 'production') {
  config = {
    env: Env,
    baseUrl: 'https://xarh.sprucesmart.com/api/v1/',  //正式地址
    // baseUrl: 'https://api-dev.sprucesmart.com/xarh/api/v1/',  //测试地址
    baseUrl1: 'https://xarh.sprucesmart.com/api/v3/',  //正式地址
    // baseUrl1: 'https://api-dev.sprucesmart.com/xarh/api/v3/',  //测试地址
    baseUrl2: 'https://xarh.sprucesmart.com/api/v5/',  //正式地址
    // baseUrl2: 'https://api-dev.sprucesmart.com/xarh/api/v5/',  //测试地址
  }
}

export default config



// WEBPACK FOOTER //
// ./src/config/config.js